<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    {{ $t('org.billing.AWS Account') }}
                </h4>
            </div>
            <a
                data-action="collapse"
                :class="{ rotate: isCollapsed }"
                @click="triggerCollapse"
                class="mr-2"
            >
                <feather-icon
                    icon="ChevronDownIcon"
                    size="16"
                />
            </a>
        </div>
        <div
            class="card-body"
            v-if="noData"
            style="text-align:center;"
        >
            {{ $t("org.message.No Data") }}
        </div>
        <div
            v-else
            ref="REF_DYNAMICSEARCH_MONTHLY"
        >
            <VsSvgBar
                :data="chartData"
                xKey="key"
                :yKeys="['cost']"
                :barColors="barColors"
                :barPaddingRate="0.2"
                :multiOffset="false"
                :width="width"
                :height="height"
                :xAxis="true"
                :yAxis="true"
                :labelRotate="0"
                :tickSize="0.7"
                :tickPadding="15"
                :yGrid="5"
                :labelColor="themeColors.currentColor"
                barLabel
                xLabel
                yLabel
            >
                <template v-slot:bar-label="{ item }">
                    {{ $_getDollar(item.title) }}
                </template>
                <template v-slot:x-axis="{ item }">
                    {{ item.label }}
                </template>
                <template v-slot:y-axis="{ item }">
                    {{ __toKFormat(item.label) }}
                </template>
            </VsSvgBar>
        </div>
        <b-collapse
            v-model="visible"
            :visible="visible"
            class="card-content"
        >
            <b-table-simple
                no-border-collapse
                sticky-header
            >
                <b-tbody>
                    <b-tr v-for="(item, index) in filterdProject" :key="index">
                        <b-td :style="`word-break:break-all;${selectedProject && selectedProject.projectIdx === item.projectIdx ? 'font-weight: bold' : undefined }`">
                                {{ item.usageAccountId }} {{ item.projectName }}
                        </b-td>
                        <b-td class="text-right" style="width:30%;">
                            {{ item.cost ? $_getDollar(item.cost) : undefined }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-collapse>
    </b-card>
</template>

<script>
import { getCurrentInstance, computed, ref, toRefs, onUpdated, onMounted, onUnmounted } from '@vue/composition-api'
import useCommonData from '@/composables/useCommonData'
import { VsSvgBar } from '@/libs/vuesign/chart'
export default {
    components: {
        VsSvgBar
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        projects: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        selectedProject: {
            type: [Object, String],
            default: function () {
                return {}
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const { __toKFormat } = useCommonData()
        const visible = ref(false)
        const isCollapsed = ref(false)
        const height = 230
        const width = ref(0)
        const { data, themeColors, selectedProject } = toRefs(props)
        const noData = computed(() => !data.value.length)
        const barColors = computed(() => {
            return {
                cost: themeColors.value.primary
            }
        })
        const chartData = computed(() => data.value.length > 5 ? data.value.slice(0, 5) : data.value)
        const accountMaps = computed(() => {
            return data.value.reduce((accumulator, currentValue) => {
                accumulator[currentValue.key] = currentValue
                return accumulator
            }, {})
        })
        const sorter = (a, b) => {
            if (selectedProject.value && selectedProject.value.projectIdx === b.projectIdx) {
                return 1
            }
            if (!b.cost) {
                return -1
            } else {
                return b.cost - a.cost
            }
        }
        const selectedGroup = computed(() => store.getters.selectedGroup)
        const groupProjectMap = computed(() => store.getters.groupProjectMap)
        const projects = computed(() => store.getters.projects)
        const groupOptions = computed(() => selectedGroup.value?.groupIdx
            ? groupProjectMap.value[selectedGroup.value.groupIdx]
            : projects.value)
        const filterdProject = computed(() => {
            return groupOptions.value.map(item => {
                return {
                    ...item,
                    cost: accountMaps.value[item.usageAccountId] && accountMaps.value[item.usageAccountId].cost
                }
            }).sort(sorter)
        })
        const triggerCollapse = () => {
            visible.value = !visible.value
        }
        const handlerBarClick = (item) => {
            const usageAccountId = data.value[item.data.index].key
            const project = filterdProject.value.find(item => item.usageAccountId === usageAccountId)
            context.emit('filter:project', { project: data.value.length === 1 ? '' : project })
        }
        const REF_DYNAMICSEARCH_MONTHLY = ref(null)
        const resize = () => {
            if (REF_DYNAMICSEARCH_MONTHLY.value) {
                width.value = REF_DYNAMICSEARCH_MONTHLY.value.getBoundingClientRect().width
            }
        }
        onUpdated(resize)
        onMounted(() => {
            vm.$nextTick(() => {
                resize()
                window.addEventListener('resize', resize)
            })
        })
        onUnmounted(() => {
            window.removeEventListener('resize', resize)
        })
        return {
            REF_DYNAMICSEARCH_MONTHLY,
            __toKFormat,
            isCollapsed,
            visible,
            height,
            width,
            noData,
            barColors,
            chartData,
            filterdProject,
            triggerCollapse,
            handlerBarClick
        }
    }
}
</script>

<style>

</style>
